import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PeerAnalysis } from 'src/app/models/analysis/peer-analysis.model';
import { ListsService } from 'src/app/services/lists.service';
import { DeconcentrationAnalysis } from 'src/app/models/analysis/deconcentration-analysis.model';
import { PeersWidgetChartComponent } from './peers-widget-chart/peers-widget-chart.component';

@Component({
  selector: 'app-peers-widget',
  templateUrl: './peers-widget.component.html',
  styleUrls: ['./peers-widget.component.scss']
})
export class PeersWidgetComponent implements OnInit, OnDestroy {

  @Input() originalPA: PeerAnalysis;
  @Input() investablePA: PeerAnalysis;
  @Input() protectedPA: PeerAnalysis;
  @Input() target1PA: PeerAnalysis;
  @Input() target2PA: PeerAnalysis;
  @Input() target3PA: PeerAnalysis;

  @ViewChild('enfchart') enfChart:PeersWidgetChartComponent;
  @ViewChild('enrchart') enrChart:PeersWidgetChartComponent;
  @ViewChild('enfbchart') enfbChart:PeersWidgetChartComponent;

  user: User;
  userSubscription: Subscription;
  selectedTab: string = 'deconcentration';
  selectedType: string;
  selectedIndex: number;

  @Input() peerProducts: DeconcentrationAnalysis[] = [];

  peerAnalysis: PeerAnalysis;

  constructor(private authService: AuthService,
              private listsService: ListsService) { }

  ngOnInit(): void {
    this.listsService.loadPeerList().then(()=>{
      this.peerProducts = this.listsService.peerList;

      if (this.originalPA) {this.selectedType = 'original';}
      else if (this.investablePA) {this.selectedType = 'investable';}
      else if (this.protectedPA) {this.selectedType = 'protected';}
      else if (this.target1PA) {this.selectedType = 'target1';}
      else if (this.target2PA) {this.selectedType = 'target2';}
      else if (this.target3PA) {this.selectedType = 'target3';}
      else {this.selectedType = 'product'; this.selectedIndex = 0;}

      this.updatePeerAnalysis();
    });

    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );
    this.authService.emitUser()
  }

  ngOnDestroy() {
    if(this.userSubscription!=undefined) { this.userSubscription.unsubscribe(); }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTab = ['deconcentration', 'diversification'][event.index];
    if (this.selectedTab=='deconcentration') {
      this.enfbChart.showGraph = false;
      this.enfChart.redraw();
    } else if (this.selectedTab=='diversification') {
      this.enfChart.showGraph = false;
      this.enfbChart.redraw();
    }
  }

  onSelectedPeerChange(event) {
    this.selectedType = event.type;
    this.selectedIndex = event.index ? event.index : this.selectedIndex;

    this.updatePeerAnalysis();
  }

  async updatePeerAnalysis() {
    if (this.selectedType=='original') {this.peerAnalysis = this.originalPA;}
    else if (this.selectedType=='investable') {this.peerAnalysis = this.investablePA;}
    else if (this.selectedType=='protected') {this.peerAnalysis = this.protectedPA;}
    else if (this.selectedType=='target1') {this.peerAnalysis = this.target1PA;}
    else if (this.selectedType=='target2') {this.peerAnalysis = this.target2PA;}
    else if (this.selectedType=='target3') {this.peerAnalysis = this.target3PA;}
    else {
      let peerAnalysis = await this.listsService.loadPeerProduct(this.peerProducts[this.selectedIndex].id);
      if (this.peerAnalysis) {
        this.peerAnalysis.initFromData(peerAnalysis);
      } else {
        this.peerAnalysis = peerAnalysis;
      }
    }
  }

}
